//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { TitledContainerInner, TitledContainerText, EntityCardContent } from "components/common";
import { ProfileRoutineFooter, useProfileRoutineSnoozeAction } from "components/profileRoutine";
import TopTodoCard from "../../_partials/topTodoCard";
import { useProfileRoutineService } from "serviceHooks";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const ProfileRoutineTodo: React.FC<TodoCardProps> = (props) => {
  const profileRoutineService = useProfileRoutineService();
  const routine = props.item.profileRoutine;

  const receivedAt = routine?.routineDate ? DateHelper.formatDate(routine?.routineDate) : undefined;

  const quickActions = useProfileRoutineSnoozeAction(routine!.id, props.onActionSuccess);

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          quickActions={[quickActions]}
          descriptionHeadingTwo={routine?.name}
          descriptionheadingThree={profileRoutineService.getFrequencyName(routine?.frequency)}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Received)}: ${
            receivedAt ?? "-"
          }`}
        />
      }
      todoMainSection={
        <TitledContainerInner header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Todo)}>
          <TitledContainerText>{routine?.description}</TitledContainerText>
        </TitledContainerInner>
      }
      footer={
        <ProfileRoutineFooter
          profileRoutine={routine!}
          markAsDoneHandler={props.onActionSuccess}
          disableSuccessMessages
        />
      }
    ></EntityCardContent>
  );
};

export default ProfileRoutineTodo;
